import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { ComponentsModule } from 'src/app/components/components.module';
import { DeleteAccountComponent } from './delete-account.component';
@NgModule({
    declarations: [
        DeleteAccountComponent
    ],
    imports: [
        CommonModule,
        IonicModule,
        ReactiveFormsModule,
        ComponentsModule
    ],
})
export class DeleteAccountModule { }
